.OpenBookButton {
  top: 0.5em;
  right: 0.5em;
  height: 2em;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Book {
  color: black;
  background-color: black;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 9000;
  position: absolute;
  justify-content: center;
  align-items: center;
  flex: 1;
}
.Book .ExitBook {
  top: 0.5em;
  right: 0.5em;
  height: 2em;
  width: 2em;
  line-height: 2em;
  text-align: center;
  position: absolute;
  font-family: header;
}
.Book .InnerBook {
  display: flex;
}
.Book .LeftPage,
.Book .RightPage {
  height: 9em;
  width: 7em;
}
.Book .LeftPage img,
.Book .RightPage img {
  height: 100%;
  border: 1px solid black;
}
.Book .GoLeft,
.Book .GoRight {
  width: 3em;
  font-family: header;
}
.Book .GoLeft:hover,
.Book .GoRight:hover {
  cursor: pointer;
}
